import CryptoJS from 'crypto-js'
 

 
//DES加密 Pkcs7填充方式
const encrypt = (message, key = '8499DFDB', iv = '8499DFDB') => {
  const keyHex = CryptoJS.enc.Utf8.parse(key) // 秘钥
  const ivHex = CryptoJS.enc.Utf8.parse(iv) // 偏移量
  const option = { iv: ivHex, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 } // Pkcs7填充方式
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, option)
  return encrypted.ciphertext.toString().toUpperCase();
}
 
// 解密
const decrypt = (message, key = '8499DFDB', iv = '8499DFDB') => {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const ivHex = CryptoJS.enc.Utf8.parse(iv)
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(message)
  }, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// 通用密码解密显示函数
const decryptPassword = (encryptedPassword) => {
  if (!encryptedPassword) {
    return '';
  }
  try {
    return decrypt(encryptedPassword);
  } catch (error) {
    console.log('密码解密失败，可能不是加密格式，返回原值');
    return encryptedPassword;
  }
}
 
export {
  encrypt,
  decrypt,
  decryptPassword
}


// WEBPACK FOOTER //
// ./src/utils/des.js